// extracted by mini-css-extract-plugin
export var activeCategories = "ProductsDropdown-module--active-categories--1d361";
export var activeCategoryItem = "ProductsDropdown-module--active-category-item--8e464";
export var cards = "ProductsDropdown-module--cards--7ce89";
export var categoryLink = "ProductsDropdown-module--category-link--0831d";
export var dropdown = "ProductsDropdown-module--dropdown--70d1e";
export var dropdownContent = "ProductsDropdown-module--dropdown-content--2966c";
export var dummyLink = "ProductsDropdown-module--dummy-link--256d3";
export var icon = "ProductsDropdown-module--icon--eb74e";
export var iconWrapper = "ProductsDropdown-module--icon-wrapper--615ad";
export var isOpen = "ProductsDropdown-module--is-open--05116";
export var noCards = "ProductsDropdown-module--no-cards--0dcaf";
export var otherCategories = "ProductsDropdown-module--other-categories--36058";
export var otherCategoryItem = "ProductsDropdown-module--other-category-item--3e037";
export var productLinks = "ProductsDropdown-module--product-links--91861";
export var productsDropdown = "ProductsDropdown-module--products-dropdown--2a11d";
export var submenu = "ProductsDropdown-module--submenu--84eb8";
export var submenuWrapper = "ProductsDropdown-module--submenu-wrapper--e93ae";